import React from 'react'
import TableComponent from '../CustomComponents/TableComponent'
import PageHeader from '../../view/pageheader'
import { Button, Card, DatePicker, Form, Select, Typography } from 'antd'
import SearchComponent from '../CustomComponents/SearchComponent'

const BoxProgress = () => {
    const { Text } = Typography;
    const onFinish = values => {

    };
    const [form] = Form.useForm();
    const columns = [
        {
            title: 'Box ID',
            dataIndex: 'box_id',
            key: 'box_id',
            align: 'center',
        },
        {
            title: 'Pickup Date',
            dataIndex: 'pickup_date',
            key: 'pickup_date',
            align: 'center',
        },
        {
            title: 'Spec  ID',
            dataIndex: 'spec_id',
            key: 'spec_id',
            align: 'center',

        },

        {
            title: 'Last EventStage',
            dataIndex: 'event_stage',
            key: 'event_stage',
            align: 'center',


        },
        {
            title: 'Box State',
            dataIndex: 'box_state',
            key: 'box_state',
            align: 'center',


        },


    ]
    const dataSource = [{
        key: '1',
        box_id: '123450001',
        spec_id: '12345',
        pickup_date: '15/10/2023',
        event_stage: 'WareHouse',
        box_state: 'In Production',
    }, {
        key: '2',
        box_id: '123450002',
        spec_id: '12345',
        pickup_date: '16/10/2023',
        event_stage: 'FInal QC',
        box_state: 'Completed',

    }, {
        key: '3',
        box_id: '123450003',
        spec_id: '12345',
        pickup_date: '17/10/2023',
        event_stage: 'Delivered',
        box_state: 'Awaiting Review',
    }
    ]
    return (
        <>
            <>
                <PageHeader HeaderText="Box Progress Report" Breadcrumb={[{ name: "Box Progress Report" }]} />
                  <Card style={{ marginTop: "-28px", }} title={'Box Progress Report'}
                    extra={
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexWrap: "wrap",
                                gap: "12px",
                                margin: "16px 0"
                            }}
                        >

                            {/* Left Side: Search + Buttons */}
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    flexWrap: "wrap"
                                }}
                            >
                                <SearchComponent
                                    style={{ width: "300px" }}
                                    placeHolder="Search Box Number"
                                />
                                <Button className="primary-btn rounded-4">
                                    Search Box Number
                                </Button>



                            </div>



                        </div>
                    }
                >
                    <Form
                        form={form}
                        layout="inline"
                        onFinish={onFinish}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                            padding: "8px 0",
                            flexWrap: "nowrap", // ensures it stays in one line
                        }}
                    >
                        {/* Customer Dropdown */}
                        <Text strong>Spec ID</Text>
                        <Form.Item name="spec_id" style={{ marginBottom: 0 }}>
                            <Select placeholder="Select Spec ID" style={{ width: 160 }}>
                                <Select.Option value="s1">123456</Select.Option>
                                <Select.Option value="s2">987654</Select.Option>
                            </Select>
                        </Form.Item>
                        <Text strong>Box State </Text>
                        <Form.Item name="customer" style={{ marginBottom: 0 }}>
                            <Select placeholder="Select Customer" style={{ width: 160 }}>
                                <Select.Option value="c1">Final QC</Select.Option>
                                <Select.Option value="c2">Image QC</Select.Option>
                            </Select>
                        </Form.Item>

                        {/* Spec ID Dropdown */}


                        {/* Date Picker */}
                        <Text strong>Date In:</Text>
                        <Form.Item name="date_in" style={{ marginBottom: 0 }}>
                            <DatePicker style={{ width: 160 }} />
                        </Form.Item>

                        {/* Submit Button */}
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Button type="primary" htmlType="submit">
                                Generate Report
                            </Button>
                        </Form.Item>
                    </Form>

                    <div style={{ marginTop: '20px' }}>
                        <div style={{ fontWeight: 700, fontSize: '15px', marginBottom: '10px', marginRight: '450px' }}>Progress Breakdown</div>
                        <TableComponent columns={columns} dataSource={dataSource} size={"small"} />
                    </div>
                </Card >


            </>
        </>
    )
}

export default BoxProgress